import DetectColsNumber from '../model/DetectColsNumber'

export default {
  created () {
    window.addEventListener('resize', this.detectCols)
    this.detectCols()
  },
  beforeUpdate () {
  },
  updated () {
  },
  data () {
    return {
      userVoted: localStorage.getItem('vjkVoteStack') ? JSON.parse(localStorage.getItem('vjkVoteStack'))[this.$presenter.gallery.id] === true : false,
      masonryOrdered: [],
      masonryCols: 1,
      photoIndex: 0
    }
  },
  computed: {
    storeState () {
      return this.$store.state.gallerydetail
    },
    hasNextGallery () {
      return this.currentGalleryIndex < (this.storeState.galleryList.length - 1)
    },
    hasPrevGallery () {
      return this.currentGalleryIndex > 0 && this.storeState.galleryList.length
    },
    nextGallery () {
      return this.storeState.galleryList[this.currentGalleryIndex + 1]
    },
    prevGallery () {
      return this.storeState.galleryList[this.currentGalleryIndex - 1]
    },
    hasNextPhoto () {
      return this.photoIndex < (this.gallery.photos.length - 1)
    },
    hasPrevPhoto () {
      return this.photoIndex > 0
    }
  },
  methods: {
    userVote () {
      const voteStack = localStorage.getItem('vjkVoteStack') ? JSON.parse(localStorage.getItem('vjkVoteStack')) : {}
      if (this.$presenter.gallery.id in voteStack && voteStack[this.$presenter.gallery.id]) {
        this.userVoted = voteStack[this.$presenter.gallery.id] = false
      } else {
        this.userVoted = voteStack[this.$presenter.gallery.id] = true
      }
      localStorage.setItem('vjkVoteStack', JSON.stringify(voteStack))
    },
    detectCols () {
      const oldMasonryCols = this.masonryCols
      this.masonryCols = DetectColsNumber()
      if (this.masonryCols !== oldMasonryCols) {
        this.masonryOrdered = []
      }
    },
    nextPhoto () {
      this.photoIndex++
    },
    prevPhoto () {
      this.photoIndex--
    },
    showPhoto (index) {
      this.photoIndex = index
    }
  }
}
